var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('gaia-header',{on:{"upload":function($event){return _vm.$refs.dialog.show()}}}),_c('router-view',{key:_vm.$route.fullPath}),_c('gaia-footer'),_c('materialDialog',{ref:"dialog"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }